<template>
  <v-container fluid class="pagecontainer">
    <v-layout row class="mediumMargin layouttitletop" wrap>
      <v-flex xs12>
        <span class="header-title">{{labels.header}}</span>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex pa-1 xs12 lg6>
        <v-card class="elevation-4">
          <v-card-title>
            <v-icon>fact_check</v-icon>&nbsp;
            <span class="bloctitle text-uppercase">{{labels.contractInformation}}</span>
          </v-card-title>
          <v-card-text>
            <div class="text-xs-center" v-if="!policySettingsIsLoaded && !policySettingsIsInError">
              <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </div>
            <div class="text-xs-center" v-if="policySettingsIsInError">
              <v-icon>error_outline</v-icon>
              <div>{{labels.errorLoadingData}}</div>
            </div>
            <div v-if="policySettingsIsLoaded">
              <v-layout row>
                <v-flex xs3>{{labels.policyNumber}}</v-flex>
                <v-flex xs9><span>{{policySettings.egbuCode}} {{policySettings.policyNumber}} {{policySettings.policyExtension}}</span></v-flex>
              </v-layout>
              <v-layout row mt-2>
                <v-flex xs3>{{labels.policyCurrency}}</v-flex>
                <v-flex xs9>
                    <img class="policyCurrency" :src="policyCurrencyFlag" :alt="policySettings.currency"/>
                    <span style="margin-left:5px;">{{policySettings.currency}}</span>
                </v-flex>
              </v-layout>
              <v-layout row mt-2>
                <v-flex xs3>{{labels.contactEmail}}</v-flex>
                <v-flex xs9><span>{{customerInformation.contactEmail}}</span></v-flex>
              </v-layout>
              <v-layout row mt-2>
                <v-flex xs3>{{labels.delayToActivate}}</v-flex>
                <v-flex xs9>
                  <div><strong>{{policySettings.quoteLifeCycleSettings.quoteActivationDelayFromQuotationDate}} {{$t('InsuranceAPI.ShowUser.DAYS_DESC')}}</strong> {{$t('InsuranceAPI.ShowUser.FROM_DESC')}} {{labels.startingPoints.get('quotationDate')}}</div>
                  <div><strong>{{policySettings.quoteLifeCycleSettings.quoteActivationDelayFromIssueDate}} {{$t('InsuranceAPI.ShowUser.DAYS_DESC')}}</strong> {{$t('InsuranceAPI.ShowUser.FROM_DESC')}} {{labels.startingPoints.get('issueDate')}}</div>
                </v-flex>
              </v-layout>
              <v-layout row mt-2>
                <v-flex xs3>{{labels.delayToSettle}}</v-flex>
                <v-flex xs9><span><strong>{{policySettings.coverLifeCycleSettings.stateOfDefaultDelay}} {{$t('InsuranceAPI.ShowUser.DAYS_DESC')}}</strong> {{$t('InsuranceAPI.ShowUser.FROM_DESC')}} {{labels.startingPoints.get(policySettings.coverLifeCycleSettings.stateOfDefaultDelayStartingPoint)}}</span></v-flex>
              </v-layout>
              <v-layout row mt-2>
                <v-flex xs3>{{labels.delayToClaim}}</v-flex>
                <v-flex xs9><span><strong>{{policySettings.coverLifeCycleSettings.claimDeclarationDelay}} {{$t('InsuranceAPI.ShowUser.DAYS_DESC')}}</strong> {{$t('InsuranceAPI.ShowUser.FROM_DESC')}} {{labels.startingPoints.get(policySettings.coverLifeCycleSettings.claimDeclarationDelayStartingPoint)}}</span></v-flex>
              </v-layout>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex pa-1 xs12 lg6 class="d-flex" style="flex-direction:column" v-if="showCompanyInfo">
        <v-card class="elevation-4">
          <v-card-title>
            <v-icon>business</v-icon>&nbsp;
            <span class="bloctitle text-uppercase">{{labels.myCompany}}</span>
          </v-card-title>
          <v-card-text>
            <div class="text-xs-center" v-if="!customerInformationIsLoaded">
              <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </div>
            <div v-else>
              <v-layout row>
                <v-flex xs12><span>{{customerInformation.company.name}}</span></v-flex>
              </v-layout>
              <v-layout row mt-2>
                <v-flex xs12><span>{{customerInformation.company.streetNumber}} {{customerInformation.company.streetName}}</span></v-flex>
              </v-layout>
              <v-layout row mt-2>
                <v-flex xs12><span>{{customerInformation.company.postCode}} {{customerInformation.company.city}}</span></v-flex>
              </v-layout>
              <v-layout row mt-2>
                <v-flex xs12><span>&nbsp;</span></v-flex>
              </v-layout>
              <v-layout row mt-2>
                <v-flex xs12><span>{{customerInformation.company.mainIdentifierTypeCode}} {{customerInformation.company.mainIdentifierValue}}</span></v-flex>
              </v-layout>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row mt-2 v-if="showUserAccounts">
      <v-flex pa-1 xs12>
        <v-card class="elevation-4">
          <v-card-title>
            <v-icon>people</v-icon>&nbsp;
            <span class="bloctitle text-uppercase">{{labels.userAccounts}}</span>
          </v-card-title>
          <v-card-text>
            <div class="text-xs-center" v-if="!customerInformationIsLoaded">
              <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </div>
            <v-list v-else>
              <v-subheader v-if="activeUserAccounts.length > 0 && inactiveUserAccounts.length > 0">{{labels.active}}</v-subheader>
              <v-list-tile v-for="item in activeUserAccounts" :key="item.email" avatar @click="()=>{}">
                <v-list-tile-avatar>
                  <v-icon>face</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{item.email}}</v-list-tile-title>
                  <v-list-tile-sub-title>{{item.firstName}} {{item.lastName}}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-subheader v-if="inactiveUserAccounts.length > 0">{{labels.inactive}}</v-subheader>
              <v-list-tile v-for="item in inactiveUserAccounts" :key="item.email" avatar @click="()=>{}">
                <v-list-tile-avatar>
                  <v-icon>face</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{item.email}}</v-list-tile-title>
                  <v-list-tile-sub-title>{{item.firstName}} {{item.lastName}}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import accountApi from '@/services/AccountApi'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      labels: {
        header: this.$t('InsuranceAPI.ShowUser.MY_ACCOUNT_TITLE'),
        contractInformation: this.$t('InsuranceAPI.ShowUser.CONTRACT_INFORMATION_SUB_TITLE'),
        myCompany: this.$t('InsuranceAPI.ShowUser.MY_COMPANY_SUB_TITLE'),
        userAccounts: this.$t('InsuranceAPI.ShowUser.USER_ACCOUNTS_SUB_TITLE'),
        policyNumber: this.$t('InsuranceAPI.ShowUser.POLICY_NUMBER_FIELD_NAME'),
        policyCurrency: this.$t('InsuranceAPI.ShowUser.CURRENCY_FIELD_NAME'),
        contactEmail: this.$t('InsuranceAPI.ShowUser.CLAIM_CONTACT_EMAIL_FIELD_NAME'),
        delayToActivate: this.$t('InsuranceAPI.ShowUser.DELAY_TO_ACTIVATE_QUOTE_FIELD_NAME'),
        delayToSettle: this.$t('InsuranceAPI.ShowUser.DELAY_TO_SETTLE_COVER_FIELD_NAME'),
        delayToClaim: this.$t('InsuranceAPI.ShowUser.DELAY_TO_FILE_CLAIM_FIELD_NAME'),
        startingPoints: new Map([
          ['quotationDate', this.$t('InsuranceAPI.ShowUser.QUOTATION_DATE_DESC')],
          ['issueDate', this.$t('InsuranceAPI.ShowUser.INVOICE_ISSUE_DATE_DESC')],
          ['dueDate', this.$t('InsuranceAPI.ShowUser.INVOICE_DUE_DATE_DESC')],
          ['QuoteDateToDueDate', this.$t('InsuranceAPI.ShowUser.QUOTATION_DATE_DESC')],
          ['AfterCoverQuotationDate', this.$t('InsuranceAPI.ShowUser.QUOTATION_DATE_DESC')],
          ['AfterInvoiceIssueDate', this.$t('InsuranceAPI.ShowUser.INVOICE_ISSUE_DATE_DESC')]
        ]),
        active: 'Active',
        inactive: 'Inactive',
        errorLoadingData: 'We had some problem loading this data'
      },
      customerInformationIsLoaded: false,
      customerInformationIsInError: false,
      customerInformation: {},
      policySettingsIsLoaded: false,
      policySettingsIsInError: false,
      policySettings: {}
    }
  },
  async mounted () {
    try {
      this.customerInformation = await this.getCustomerInformation()
      this.customerInformationIsLoaded = true
    } catch (error) {
      this.customerInformationIsInError = true
    }

    try {
      this.policySettings = await this.getPolicySettings()
      this.policySettingsIsLoaded = true
    } catch (error) {
      this.policySettingsIsInError = true
    }
  },
  methods: {
    async getPolicySettings () {
      let settings = await accountApi.getPolicySettings()
      let policySettings = {
        policyNumber: settings[0].policyNumber,
        policyExtension: settings[0].policyExtension,
        egbuCode: settings[0].egbuCode,
        currency: settings[0].currency,
        quoteLifeCycleSettings: {
          quoteActivationDelayFromQuotationDate: settings[0].quoteLifeCycleSetting.maxActivationPeriodFromQuotationDate,
          quoteActivationDelayFromIssueDate: settings[0].quoteLifeCycleSetting.maxActivationPeriodFromIssueDate
        },
        coverLifeCycleSettings: {
          stateOfDefaultDelay: settings[0].quoteLifeCycleSetting.daysAfterIssueDateBeforeDefault > 0 ? settings[0].quoteLifeCycleSetting.daysAfterIssueDateBeforeDefault : settings[0].quoteLifeCycleSetting.daysAfterDueDateBeforeDefault,
          stateOfDefaultDelayStartingPoint: settings[0].quoteLifeCycleSetting.daysAfterIssueDateBeforeDefault > 0 ? 'issueDate' : 'dueDate',
          claimDeclarationDelay: settings[0].quoteLifeCycleSetting.maxDaysFromIssueDateForFilingClaims > 0 ? settings[0].quoteLifeCycleSetting.maxDaysFromIssueDateForFilingClaims : settings[0].quoteLifeCycleSetting.maxDaysFromDueDateForFilingClaims,
          claimDeclarationDelayStartingPoint: settings[0].quoteLifeCycleSetting.maxDaysFromIssueDateForFilingClaims > 0 ? 'issueDate' : 'dueDate'
        }
      }
      return policySettings
    },
    async getCustomerInformation () {
      let result = await accountApi.getUserAccountInfo()
      return result
    }
  },
  computed: {
    ...mapState('countries', ['currencyFlags']),
    showUserAccounts: function () {
      return !this.customerInformationIsInError && this.customerInformation && this.customerInformation.userAccounts && this.customerInformation.userAccounts.length > 0
    },
    showCompanyInfo: function () {
      return !this.customerInformationIsInError && this.customerInformation && this.customerInformation.company
    },
    activeUserAccounts: function () {
      if (!this.customerInformationIsLoaded || !this.customerInformation.userAccounts) {
        return []
      }

      return this.customerInformation.userAccounts.filter(x => x.isActive === true)
    },
    inactiveUserAccounts: function () {
      if (!this.customerInformationIsLoaded || !this.customerInformation.userAccounts) {
        return []
      }

      return this.customerInformation.userAccounts.filter(x => x.isActive === false)
    },
    policyCurrencyFlag: function () {
      if (!!this.policySettings && !!this.policySettings.currency) {
        let currency = this.currencyFlags.find(f => f.currency.toUpperCase() === this.policySettings.currency.toUpperCase())
        return currency.flag
      } else {
        return ''
      }
    }
  }
}
</script>

<style>
.bloctitle {
    font-size: 15px;
}

.policyCurrency{
    display: inline-block;
    vertical-align:middle;
    height: 16px;
    object-fit: contain;
}
</style>
